import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';

interface UserState {
  sidePanelOpen?: boolean;
  setSidePanelOpen: (isOpen?: boolean) => void;
}

const useUIStore = create<UserState>()(
  devtools(
    persist(
      (set) => ({
        sidePanelOpen: undefined,
        setSidePanelOpen: (isOpen?: boolean) => set({ sidePanelOpen: isOpen }),
      }),
      { name: 'ui-storage', storage: createJSONStorage(() => localStorage) }
    )
  )
);

export default useUIStore;
